// Optional descriptors are data only. They never select or validate a score.
const text = (v, max, label, required = false) => {
  if (typeof v !== 'string' || v.length > max || /[\x00-\x08\x0B\x0C\x0E-\x1F]/.test(v) || /<\/?[a-zA-Z][^>]*>/.test(v) || (required && !v.trim())) throw Error(`${label} invalide.`);
  return v;
};
const revision = v => { if (!Number.isSafeInteger(v) || v < 1) throw Error('Version de grille invalide.'); return v; };
export function normalizeCriterionDetails(c) {
  const out = {};
  if (c.description !== undefined) out.description = text(c.description, 2000, 'Description du critère');
  if (c.levels !== undefined) {
    if (!Array.isArray(c.levels) || c.levels.length > 10) throw Error('Un critère accepte au plus 10 niveaux.');
    const ids = new Set();
    out.levels = c.levels.map(level => {
      if (!level || typeof level !== 'object') throw Error('Niveau invalide.');
      const id = text(level.id, 100, 'Identifiant du niveau', true);
      if (ids.has(id)) throw Error('Identifiant de niveau en double.');
      ids.add(id);
      if (typeof level.min !== 'number' || typeof level.max !== 'number' || !Number.isFinite(level.min) || !Number.isFinite(level.max) || level.min < 0 || level.max < level.min || level.max > Number(c.max)) throw Error('Les bornes des niveaux doivent rester entre zéro et le maximum du critère.');
      return { id, label: text(level.label, 120, 'Libellé du niveau', true), description: text(level.description ?? '', 2000, 'Description du niveau'), min: level.min, max: level.max };
    });
    const sorted = [...out.levels].sort((a, b) => a.min - b.min);
    for (let i = 1; i < sorted.length; i++) if (sorted[i].min <= sorted[i - 1].max) throw Error('Les plages de niveaux ne doivent pas se chevaucher, bornes comprises.');
  }
  return out;
}
export function snapshotCriteria(criteria) {
  if (!Array.isArray(criteria) || !criteria.length || criteria.length > 30) throw Error('Ajoutez de 1 à 30 critères.');
  const ids = new Set();
  const result = criteria.map(c => {
    if (!c || typeof c !== 'object') throw Error('Critère invalide.');
    const id = text(c.id, 100, 'Identifiant du critère', true);
    if (ids.has(id)) throw Error('Identifiant de critère en double.');
    ids.add(id);
    const max = Number(c.max);
    if (typeof c.max === 'boolean' || !Number.isFinite(max) || max <= 0 || max > 1000) throw Error('Maximum du critère invalide.');
    return { id, label: text(c.label, 250, 'Intitulé du critère', true), max, ...normalizeCriterionDetails(c) };
  });
  if (result.reduce((n, c) => n + c.max, 0) > 1000) throw Error('Le total ne peut dépasser 1 000 points.');
  return result;
}
export function validateRubricDetails(r) {
  const criteria = snapshotCriteria(r.criteria);
  const totalMax = criteria.reduce((n, c) => n + c.max, 0);
  if (r.totalMax !== undefined && (typeof r.totalMax !== 'number' || !Number.isFinite(r.totalMax) || Math.abs(r.totalMax - totalMax) > 0.000001)) throw Error('Total de grille incohérent.');
  if (r.revision !== undefined) revision(r.revision);
  return r;
}
export function prepareRubricRevision(r, previous) {
  const criteria = snapshotCriteria(r.criteria);
  text(r.name, 200, 'Nom de la grille', true);
  if (previous && previous.id !== r.id) throw Error('La version doit appartenir à la même grille.');
  const before = previous ? revision(previous.revision ?? 1) : 0;
  const next = before + 1;
  revision(next);
  return { ...r, criteria, revision: next, totalMax: criteria.reduce((n, c) => n + c.max, 0) };
}
export function createRubricSnapshot(r) {
  validateRubricDetails(r);
  return { rubricId: text(r.id ?? '', 100, 'Identifiant de grille'), name: text(r.name ?? '', 200, 'Nom de grille'), revision: revision(r.revision ?? 1), criteria: snapshotCriteria(r.criteria) };
}
export function normalizeRubricSnapshot(s) {
  if (!s || typeof s !== 'object' || Array.isArray(s)) throw Error('Historique de grille invalide.');
  return { rubricId: text(s.rubricId, 100, 'Identifiant de grille'), name: text(s.name, 200, 'Nom de grille'), revision: revision(s.revision), criteria: snapshotCriteria(s.criteria) };
}
